import React from 'react';
import { WaitlistSection } from '../components/WaitlistSection';
import { Sparkles, KeyRound, Zap } from 'lucide-react';

export const WaitlistPage: React.FC = () => {
  return (
    <div className="canvas-dark" style={{ minHeight: '100vh', paddingTop: '130px', paddingBottom: '96px', backgroundColor: '#121212' }}>
      
      {/* Header */}
      <header className="container" style={{ padding: '0 20px 48px', maxWidth: '880px', textAlign: 'center' }}>
        <div className="eyebrow" style={{ color: '#6D7CFF', marginBottom: '12px' }}>
          Private Beta Cohort
        </div>
        <h1 
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: 'clamp(32px, 5vw, 52px)',
            fontWeight: 400,
            lineHeight: 1.15,
            letterSpacing: '-1.2px',
            color: '#FFFFFF',
            margin: '0 auto 16px',
            maxWidth: '780px'
          }}
        >
          Request Early Access &amp; Sandbox Keys
        </h1>
        <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: '16px', color: '#D7D7D7', lineHeight: 1.6, maxWidth: '680px', margin: '0 auto' }}>
          Join over 1,400 engineering teams on the private access waitlist. Get early sandbox API keys, priority engineering onboarding, and lock in 50% lifetime platform pricing.
        </p>
      </header>

      {/* Perks Strip */}
      <section className="container" style={{ maxWidth: '880px', padding: '0 20px 48px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' }}>
          
          <div 
            style={{ 
              backgroundColor: '#1A1A1A', 
              border: '1px solid rgba(255, 255, 255, 0.08)', 
              borderRadius: '8px', 
              padding: '24px' 
            }}
          >
            <div style={{ color: '#6D7CFF', marginBottom: '12px' }}><Zap size={22} /></div>
            <h4 style={{ fontFamily: "'Outfit', sans-serif", fontSize: '16px', fontWeight: 500, color: '#FFFFFF', margin: '0 0 8px' }}>
              Priority Onboarding
            </h4>
            <p style={{ fontSize: '13px', color: '#D7D7D7', lineHeight: 1.6, margin: 0 }}>
              Direct private Slack / Discord channel with Draway core architects during your sandbox integration.
            </p>
          </div>

          <div 
            style={{ 
              backgroundColor: '#1A1A1A', 
              border: '1px solid rgba(255, 255, 255, 0.08)', 
              borderRadius: '8px', 
              padding: '24px' 
            }}
          >
            <div style={{ color: '#6D7CFF', marginBottom: '12px' }}><KeyRound size={22} /></div>
            <h4 style={{ fontFamily: "'Outfit', sans-serif", fontSize: '16px', fontWeight: 500, color: '#FFFFFF', margin: '0 0 8px' }}>
              Instant Sandbox Keys
            </h4>
            <p style={{ fontSize: '13px', color: '#D7D7D7', lineHeight: 1.6, margin: 0 }}>
              Test WebAuthn passkeys, WhatsApp OTP, SMS, and multi-tenant domain verification in an isolated test environment.
            </p>
          </div>

          <div 
            style={{ 
              backgroundColor: '#1A1A1A', 
              border: '1px solid rgba(255, 255, 255, 0.08)', 
              borderRadius: '8px', 
              padding: '24px' 
            }}
          >
            <div style={{ color: '#6D7CFF', marginBottom: '12px' }}><Sparkles size={22} /></div>
            <h4 style={{ fontFamily: "'Outfit', sans-serif", fontSize: '16px', fontWeight: 500, color: '#FFFFFF', margin: '0 0 8px' }}>
              50% Lifetime Price Lock
            </h4>
            <p style={{ fontSize: '13px', color: '#D7D7D7', lineHeight: 1.6, margin: 0 }}>
              All early beta participants lock in 50% off all production tier plans for the lifetime of their organization.
            </p>
          </div>

        </div>
      </section>

      {/* Form with interactive ticket */}
      <WaitlistSection />
    </div>
  );
};

export default WaitlistPage;
